// import React, { useState, useRef, useEffect } from "react";
// import { Table, Input, Label } from "reactstrap";
// import Modal from 'react-bootstrap/Modal';
// import { useLoader } from "../../_helper/LoaderContext";
// import { masterDoctor, masterPackage, masterTest, testOrder } from "./services/search-patient";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router";
// import InvoiceModal from "../invoiceModel";
// import { useTranslation } from "react-i18next";
// import CurrencyAmountInput from "../CurrencyAmountInput";
// import { useCurrency } from "../../_helper/currencyContext";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import { getDashboardData } from "../Dashboard/service/dashboard-service";
// import { useCollection } from "../../_helper/dailyCollection";

// export default function PatientTest({ selectedPatient }) {
//     const [mode, setMode] = useState("Tests");
//     const [masterOptions, setMasterOptions] = useState([]); // Full list from API
//     const [search, setSearch] = useState("");
//     const [isOpen, setIsOpen] = useState(false);
//     const navigate = useNavigate()

//     // Selected items
//     const [selectedTests, setSelectedTests] = useState([]);
//     const [selectedPackages, setSelectedPackages] = useState([]);
//     const { t } = useTranslation()

//     // Combined for display and calculations
//     const allSelectedItems = [...selectedTests, ...selectedPackages];

//     const [discountPercent, setDiscountPercent] = useState("");
//     const [discountAmount, setDiscountAmount] = useState("0");
//     const [taxPercent, setTaxPercent] = useState("0");
//     const [selectedDoctorId, setSelectedDoctorId] = useState("");

//     const [show, setShow] = useState(false);
//     const [showRecipt, setShowRecipt] = useState(false);
//     const [paymentType, setPaymentType] = useState('full');
//     const [paidAmount, setPaidAmount] = useState(0);
//     const [paymentMethod, setPaymentMethod] = useState("Cash");
//     const [apiData, setApiData] = useState({})
//     const [paidAmountInSelectedCurrency, setPaidAmountInSelectedCurrency] = useState(0);
//     const [selectedPaymentCurrency, setSelectedPaymentCurrency] = useState("INR");

//     const { setLoading } = useLoader();
//     const [doctor, setDoctor] = useState([]);
//     const dropdownRef = useRef(null);

//     // Calculations
//     const totalItemsAmount = allSelectedItems.reduce((sum, item) => sum + item.price, 0);
//     const discountAmt = discountAmount ? Number(discountAmount) : 0;
//     const amountAfterDiscount = totalItemsAmount - discountAmt;
//     // const taxAmt = Math.round(amountAfterDiscount * (Number(taxPercent) / 100));
//     const taxAmt = Number((amountAfterDiscount * (Number(taxPercent) / 100)).toFixed(2));
//     const finalTotal = amountAfterDiscount + taxAmt;
//     const { getCurrencySymbol, convertCurrency, currency } = useCurrency();

//     const [error, setError] = useState("");
//     const [errorDr, setErrorDr] = useState("");
//     const [currencyFor, setCurrencyFor] = useState("");
//     const [user, setUser] = useState({});
//     const [payment, setPayment] = useState({});
//     const [settleLater, setSettleLater] = useState(false);
//     const { setDaily } = useCollection()
//     const [overpaymentConfirmed, setOverpaymentConfirmed] = useState(false);

//     useEffect(() => {
//         loadData();
//     }, []);

//     useEffect(() => {
//         getMasterDoctor();
//         const data = JSON.parse(localStorage.getItem("currentLab"))
//         setUser(data)
//     }, []);

//     // Update when finalTotal or paymentType changes
//     useEffect(() => {
//         if (paymentType === 'full') {
//             setPaidAmount(finalTotal);
//             setPaidAmountInSelectedCurrency(finalTotal);
//         } else {
//             setPaidAmount(0);
//             setPaidAmountInSelectedCurrency(0);
//         }
//     }, [paymentType, finalTotal, selectedPaymentCurrency]);

//     useEffect(() => {
//         if (discountAmount && totalItemsAmount > 0) {
//             const perc = Math.round((Number(discountAmount) / totalItemsAmount) * 100);
//             setDiscountPercent(perc.toString());
//         }
//     }, [discountAmount, totalItemsAmount]);

//     useEffect(() => {
//         if (paymentType === 'full') {
//             setPaidAmount(finalTotal);
//         } else {
//             setPaidAmount(0);
//         }
//     }, [paymentType, finalTotal]);

//     const loadData = async () => {
//         setLoading(true);
//         try {
//             const data = await masterTest();
//             const mapped = data.data.data.allItems.map(item => ({
//                 id: item._id,
//                 name: item.name,
//                 price: item.cost || item.price || 0,
//                 isPackaged: item.isPackaged || false
//             }));
//             setMasterOptions(mapped);
//         } catch (err) {
//             console.log(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const getMasterDoctor = async () => {
//         setLoading(true);
//         try {
//             const res = await masterDoctor();
//             if (res.data.success) setDoctor(res.data.data);
//         } catch (err) {
//             console.log(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Live filtered options
//     const availableOptions = masterOptions.filter(opt =>
//         opt.name.toLowerCase().includes(search.toLowerCase()) &&
//         !allSelectedItems.some(sel => sel.id === opt.id)
//     );

//     const handleSearch = (e) => {
//         setSearch(e.target.value);
//     };

//     const handleSelect = (option) => {
//         if (option.isPackaged) {
//             setSelectedPackages(prev => [...prev, option]);
//         } else {
//             setSelectedTests(prev => [...prev, option]);
//         }
//         setIsOpen(false);
//         setSearch("");
//     };

//     const handleDelete = (id) => {
//         setSelectedTests(prev => prev.filter(t => t.id !== id));
//         setSelectedPackages(prev => prev.filter(p => p.id !== id));
//     };

//     useEffect(() => {
//         const clickOutside = (e) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//                 setIsOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", clickOutside);
//         return () => document.removeEventListener("mousedown", clickOutside);
//     }, []);

//     const handlePaymentTypeChange = (e) => {
//         setPaymentType(e.target.value);
//         setSettleLater(false)
//     };

//     const openPaymentModal = () => {
//         if (allSelectedItems.length === 0) {
//             setError("Please select at least one Test or Package")
//             return;
//         }
//         setShow(true);
//     };

//     const handleSavePayment = async () => {
//         if (allSelectedItems.length === 0) {
//             setError("Please select at least one Test or Package");
//             return;
//         }

//         const selectedDoctor = doctor.find(d => d._id === selectedDoctorId);
//         const commissionPercentage = selectedDoctor?.commissionPercent ?? 0;

//         // Base currency amounts (INR by default)
//         const baseTotalItemsAmount = totalItemsAmount;
//         const baseDiscountAmt = discountAmt;
//         const baseAmountAfterDiscount = amountAfterDiscount;
//         const baseTaxAmt = taxAmt;
//         const baseFinalTotal = finalTotal;
//         const baseDoctorCommissionAmount = selectedDoctor
//             ? Number(((baseAmountAfterDiscount * commissionPercentage) / 100).toFixed(2))
//             : 0;

//         // Selected payment currency
//         const selectedCurrency = currencyFor || user.baseCurrency;
//         const totalInSelectedCurrency = convertCurrency(baseTotalItemsAmount, user.baseCurrency, selectedCurrency);
//         const discountInSelected = convertCurrency(baseDiscountAmt, user.baseCurrency, selectedCurrency);
//         const taxInSelected = convertCurrency(baseTaxAmt, user.baseCurrency, selectedCurrency);
//         const netTotalInSelected = convertCurrency(baseFinalTotal, user.baseCurrency, selectedCurrency);
//         const doctorCommissionInSelected = baseDoctorCommissionAmount;

//         // Paid amount in selected currency
//         const paidInSelected = paymentType === 'full'
//             ? netTotalInSelected
//             : Number(paidAmountInSelectedCurrency || paidAmount || 0);

//         const dueInSelected = netTotalInSelected - paidInSelected;

//         // Determine payment status
//         let isFullPayment = paymentType === "full";
//         let isPartialPayment = paymentType === "partial";
//         let isSettled = isPartialPayment && settleLater;
//         let isPartialPaid = isPartialPayment && !settleLater;

//         // NEW CONDITION 1: If partial but paid full amount → treat as full payment
//         if (isPartialPayment && paidInSelected >= netTotalInSelected) {
//             isFullPayment = true;
//             isPartialPayment = false;
//             isSettled = false;
//             isPartialPaid = false;
//         }

//         let isPaid = isFullPayment || (isPartialPayment && settleLater); // settleLater means marked as settled

//         // NEW CONDITION 2: If paid > net total → ask for confirmation
//         if (paidInSelected > netTotalInSelected && !overpaymentConfirmed) {
//             const result = await Swal.fire({
//                 title: 'Overpayment Detected',
//                 icon: 'warning',
//                 html: `
//             <p>You are paying <strong>${getCurrencySymbol(selectedCurrency)}${paidInSelected.toFixed(2)}</strong></p>
//             <p>Which is more than the payable amount: <strong>${getCurrencySymbol(selectedCurrency)}${netTotalInSelected.toFixed(2)}</strong></p>
//             <p class="text-danger mt-3 fw-bold">
//                 Extra: ${getCurrencySymbol(selectedCurrency)}${(paidInSelected - netTotalInSelected).toFixed(2)}
//             </p>
//         `,
//                 showCancelButton: true,
//                 confirmButtonText: 'Yes, Proceed Anyway',
//                 cancelButtonText: 'Cancel',
//                 confirmButtonColor: '#3085d6',
//                 cancelButtonColor: '#d33',
//                 reverseButtons: true,
//             });

//             if (!result.isConfirmed) {
//                 setLoading(false);
//                 return;
//             }

//             // Treat overpayment as full payment
//             isPaid = true;
//             setOverpaymentConfirmed(true);
//         }

//         setLoading(true);

//         try {
//             const payload = {
//                 patient: {
//                     patientId: selectedPatient._id,
//                     name: selectedPatient.fname,
//                     contact: selectedPatient.contact,
//                     email: selectedPatient.email,
//                     age: selectedPatient.age,
//                     gender: selectedPatient.gender,
//                     patientType: "walkin"
//                 },
//                 lab: {
//                     labId: user._id,
//                     name: user.facility_name,
//                     address: user.contact_person?.address,
//                     createdByName: user.contact_person.first_name + " " + user.contact_person.last_name
//                 },
//                 doctor: selectedDoctor ? {
//                     doctorId: selectedDoctor._id,
//                     name: `${selectedDoctor.fname} ${selectedDoctor.lname || ""}`,
//                     email: selectedDoctor.email || "",
//                     mobile: selectedDoctor.mobile || "",
//                     specialization: selectedDoctor.specialization || "",
//                     commissionPercentage: commissionPercentage
//                 } : null,

//                 tests: selectedTests.map(t => ({ testId: t.id })),
//                 packages: selectedPackages.map(p => ({ packageId: p.id })),

//                 payment: {
//                     currency: selectedCurrency,
//                     paymentMode: paymentMethod,

//                     totalPrice: Number(totalInSelectedCurrency.toFixed(2)),
//                     paid: Number(paidInSelected.toFixed(2)),
//                     netTotal: Number(netTotalInSelected.toFixed(2)),
//                     due: Number(dueInSelected < 0 ? 0 : dueInSelected.toFixed(2)), // due can't be negative

//                     discount: {
//                         amount: Number(discountInSelected.toFixed(2)),
//                         percentage: discountPercent ? Number(discountPercent) : 0
//                     },

//                     doctorCommissionPercentage: commissionPercentage,
//                     doctorCommissionAmount: Number(doctorCommissionInSelected.toFixed(2)),

//                     isIGST: true,
//                     IGST: Number(taxInSelected.toFixed(2)),
//                     CGST: 0,
//                     SGST: 0,
//                     IGSTPercentage: Number(taxPercent),
//                     CGSTPercentage: 0,
//                     SGSTPercentage: 0,

//                     baseCurrency: user.baseCurrency || "INR",
//                     baseTotalPrice: baseTotalItemsAmount,
//                     baseNetTotal: baseFinalTotal,
//                     basePaid: isPaid ? baseFinalTotal : 0, // basePaid only if fully paid
//                     baseDiscountAmount: baseDiscountAmt,
//                     baseIGST: baseTaxAmt,
//                     baseDoctorCommissionAmount: baseDoctorCommissionAmount,

//                     isPaid,
//                     isSettled,
//                     isPartialPaid,
//                     discounAmount: baseAmountAfterDiscount  // typo fix suggestion: discountAmount
//                 }
//             };
//             // console.log(payload)
//             const res = await testOrder(payload);
//             if (res.data.success) {
//                 toast.success(res.data.message);
//                 setShow(false);
//                 setShowRecipt(true);
//                 setApiData(res.data.data);
//                 navigate(`${process.env.PUBLIC_URL}/test-list`);
//                 setOverpaymentConfirmed(false);
//                 // Refresh dashboard collection
//                 const response = await getDashboardData();
//                 localStorage.setItem('collectionAmount', JSON.stringify(response.data.data.collectionAmount));
//                 setDaily(response.data.data.collectionAmount);
//             }
//         } catch (error) {
//             console.log(error);
//             toast.warning("Payment failed");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const selectedCurrency = currencyFor || user.baseCurrency;
//     const totalInSelectedCurrency = convertCurrency(finalTotal, user.baseCurrency, selectedCurrency);
//     const paidInSelectedCurrency = Number(paidAmount || 0);
//     const remainingInSelectedCurrency = totalInSelectedCurrency - paidInSelectedCurrency;

//     const handleSettleLaterToggle = async () => {
//         const willSettle = !settleLater;
//         const result = await Swal.fire({
//             title: willSettle ? "Are you sure?" : "Are you sure?",
//             text: willSettle ? "Do you want to settle this payment?" : "Do you want to un-settle this payment?",
//             icon: "info",
//             showCancelButton: true,
//             cancelButtonText: "No, Cancel",
//             confirmButtonText: willSettle ? "Yes, Settle it!" : "Yes, Unsettle it!",
//             reverseButtons: false,
//         });
//         if (result.isConfirmed) {
//             setSettleLater(willSettle);
//         }
//     };

//     const formatAmount = (amount) => {
//         return Number(amount || 0).toFixed(2);
//     };

//     return (
//         <>
//             <div className="row mt-4">
//                 <div className="col-md-8">
//                     <div className="p-3 tw-rounded-lg" style={{ border: "2px solid #1b255b" }}>
//                         <div className="row" ref={dropdownRef}>
//                             <div className="col-md-12">
//                                 <button type="button" className="form-select text-start" onClick={() => setIsOpen(!isOpen)}>
//                                     Search by {mode}...
//                                 </button>
//                                 {isOpen && (
//                                     <div className="position-absolute bg-white text-black border rounded shadow w-100 mt-1" style={{ zIndex: 1050, maxHeight: "230px", overflowY: "auto" }}>
//                                         <div className="p-2 border-bottom">
//                                             <input type="text" className="form-control" placeholder="Search..." value={search} onChange={handleSearch} autoFocus />
//                                         </div>
//                                         {availableOptions.length > 0 ? availableOptions.map((opt, i) => (
//                                             <div key={i} className="dropdown-item py-2 px-3" style={{ cursor: "pointer" }} onClick={() => {
//                                                 handleSelect(opt)
//                                                 setError("")
//                                             }}>
//                                                 <div className="d-flex justify-content-between">
//                                                     <span>{opt.name} {opt.isPackaged && <span className="badge bg-success ms-2">Package</span>}</span>
//                                                     <span className="text-black">{getCurrencySymbol(user.baseCurrency)}{opt.price}</span>
//                                                 </div>
//                                             </div>
//                                         )) : <div className="px-3 py-2 text-muted">No results</div>}
//                                     </div>
//                                 )}
//                                 <span className="tw-text-red-500">{error}</span>
//                             </div>
//                         </div>

//                         {/* Selected Items Table - Now shows (Package) label */}
//                         <div className="recent-table mt-3 table-responsive currency-table tw-rounded-lg tw-border tw-border-black" style={{ maxHeight: "400px" }}>
//                             <Table className="mb-0 table-center table-bordered table-hover bg-white text-dark" style={{ tableLayout: "fixed", width: "100%" }}>
//                                 <thead>
//                                     <tr>
//                                         <th className="bg-primary text-center" style={{ width: "10%" }}><b>Sr.No</b></th>
//                                         <th className="bg-primary" style={{ width: "55%" }}><b>Test Name</b></th>
//                                         <th className="bg-primary" style={{ width: "20%" }}><b>Price</b></th>
//                                         <th style={{ width: "15%" }} className="text-center bg-primary"><b>Action</b></th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {allSelectedItems.length > 0 ? (
//                                         <>
//                                             {allSelectedItems.map((item, idx) => (
//                                                 <tr key={item.id}>
//                                                     <td className="text-center" style={{ color: "black" }}>{idx + 1}</td>
//                                                     <td style={{ color: "black" }}>
//                                                         {item.name}
//                                                         {item.isPackaged && <span className="badge bg-success ms-2">Package</span>}
//                                                     </td>
//                                                     <td style={{ color: "black" }}>{getCurrencySymbol(user.baseCurrency)}{item.price}</td>
//                                                     <td style={{ color: "black" }} className="text-center">
//                                                         <i className="bi bi-trash text-danger cursor-pointer" onClick={() => handleDelete(item.id)}></i>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                             <tr className="fw-bold">
//                                                 <td></td>
//                                                 <td style={{ color: "black" }}>Total</td>
//                                                 <td style={{ color: "black" }}>{getCurrencySymbol(user.baseCurrency)}{totalItemsAmount}</td>
//                                                 <td></td>
//                                             </tr>
//                                         </>
//                                     ) : (
//                                         <tr><td colSpan={4} className="text-center tw-font-bold" style={{ color: 'black' }}>No items selected</td></tr>
//                                     )}
//                                 </tbody>
//                             </Table>
//                         </div>

//                         {/* Discount & Tax */}
//                         <div className="mt-4">
//                             <h6 className="tw-font-semibold">Discount & Tax</h6>
//                             <div className="row g-3">
//                                 <div className="col-md-4">
//                                     <label>Discount (%)</label>
//                                     <div className="input-group">
//                                         <input
//                                             type="number"
//                                             className="form-control"
//                                             value={discountPercent}
//                                             onChange={(e) => {
//                                                 const percent = Number(e.target.value);
//                                                 setDiscountPercent(percent);
//                                                 if (totalItemsAmount > 0) {
//                                                     const amount = Math.round((totalItemsAmount * percent) / 100);
//                                                     setDiscountAmount(amount.toString());
//                                                 } else {
//                                                     setDiscountAmount("0");
//                                                 }
//                                             }}
//                                         />
//                                         <span className="input-group-text">= {discountAmt}</span>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <label>Tax (GST)</label>
//                                     <select className="form-select" value={taxPercent} onChange={(e) => setTaxPercent(e.target.value)}>
//                                         <option value="0">0%</option>
//                                         <option value="5">5%</option>
//                                         <option value="12">12%</option>
//                                         <option value="18">18%</option>
//                                         <option value="28">28%</option>
//                                     </select>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <label>Referred By Doctor </label>
//                                     <select className="form-select" value={selectedDoctorId} onChange={(e) => {
//                                         setSelectedDoctorId(e.target.value)
//                                         setErrorDr("")
//                                     }}>
//                                         <option value="">Select</option>
//                                         {doctor.map(d => <option key={d._id} value={d._id}>{d.fname} {d.lname}</option>)}
//                                     </select>
//                                     <span className="tw-text-red-500">{errorDr}</span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Payment Summary */}
//                 <div className="col-md-4">
//                     <div className="p-3 tw-rounded-lg" style={{ border: "2px solid #1b255b" }}>
//                         <h5>Payment Summary</h5>
//                         <div className="mt-3">
//                             <div className="d-flex justify-content-between"><span>Amount</span><strong>{getCurrencySymbol(user.baseCurrency)}{formatAmount(totalItemsAmount)}</strong></div>
//                             <div className="d-flex justify-content-between text-danger"><span>Discount</span><strong>- {getCurrencySymbol(user.baseCurrency)}{formatAmount(discountAmt)}</strong></div>
//                             <div className="d-flex justify-content-between"><span>Tax ({taxPercent}%)</span><strong>+ {getCurrencySymbol(user.baseCurrency)}{formatAmount(taxAmt)}</strong></div>
//                             {/* <div className="d-flex justify-content-between"><span>Amount</span><strong>{getCurrencySymbol(user.baseCurrency)}{totalItemsAmount}</strong></div>
//                             <div className="d-flex justify-content-between text-danger"><span>Discount</span><strong>- {getCurrencySymbol(user.baseCurrency)}{discountAmt}</strong></div>
//                             <div className="d-flex justify-content-between"><span>Tax ({taxPercent}%)</span><strong>+ {getCurrencySymbol(user.baseCurrency)}{taxAmt}</strong></div> */}
//                             <hr />
//                             <div className="d-flex justify-content-between fs-5 fw-bold text-primary">
//                                 <span>Final Total</span><span>{getCurrencySymbol(user.baseCurrency)}{formatAmount(finalTotal)}</span>
//                                 {/* <span>Final Total</span><span>{getCurrencySymbol(user.baseCurrency)}{finalTotal}</span> */}
//                             </div>
//                         </div>
//                         <div className="mt-3 text-end">
//                             <button className="btn btn-primary me-2" onClick={openPaymentModal}>
//                                 Payment
//                             </button>
//                             <Link to={`${process.env.PUBLIC_URL}/search-patient`}>
//                                 <button className="btn btn-secondary ">Cancel</button>
//                             </Link>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Payment Modal */}
//                 <Modal show={show} onHide={() => setShow(false)}>
//                     <Modal.Header closeButton style={{ backgroundColor: "#dbffe5" }}>
//                         <Modal.Title> Process Payment</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <div className="row g-3">
//                             <div className="col-12">
//                                 <label>Payment Method</label>
//                                 <select className="form-select" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
//                                     <option>Cash</option>
//                                     <option>Card</option>
//                                     <option>UPI</option>
//                                 </select>
//                             </div>

//                             <div className="col-6">
//                                 <div className="radio radio-primary">
//                                     <Input
//                                         id="full"
//                                         type="radio"
//                                         name="paymentType"
//                                         value="full"
//                                         checked={paymentType === "full"}
//                                         onChange={handlePaymentTypeChange}
//                                     />
//                                     <Label for="full" className="mb-0 pe-2">
//                                         Full Paid
//                                     </Label>
//                                 </div>
//                             </div>
//                             <div className="col-6">
//                                 <div className="radio radio-primary">
//                                     <Input
//                                         id="partial"
//                                         type="radio"
//                                         name="paymentType"
//                                         value="partial"
//                                         checked={paymentType === "partial"}
//                                         onChange={handlePaymentTypeChange}
//                                     />
//                                     <Label for="partial" className="mb-0 pe-2">
//                                         Partial Paid
//                                     </Label>
//                                 </div>
//                             </div>

//                             <div className="col-12">
//                                 <CurrencyAmountInput
//                                     label="Paid Amount"
//                                     amount={paidAmount}
//                                     onAmountChange={(value) => setPaidAmount(value)}
//                                     onCurrencyChange={(currency) => setCurrencyFor(currency)}
//                                     disabled={paymentType === 'full'}
//                                     originalAmount={finalTotal}
//                                     defaultCurrency={user.baseCurrency}
//                                 />
//                             </div>

//                             <div className="col-12">
//                                 <div className="p-3 rounded border border-success" style={{ backgroundColor: "#f8fff9" }}>
//                                     <p className="mb-1"><strong>Payment Type:</strong> {paymentType === 'full' ? "Full Paid" : "Partial Paid"}</p>
//                                     <p className="mb-1">
//                                         <strong>Amount to Pay:</strong>{' '}
//                                         {getCurrencySymbol(selectedCurrency)}
//                                         {paymentType === 'full'
//                                             ? Number(totalInSelectedCurrency).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//                                             : Number(paidInSelectedCurrency).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//                                         } {selectedCurrency}
//                                     </p>
//                                     {paymentType === 'partial' && (
//                                         <p className="mb-0 text-danger">
//                                             <strong>Remaining:</strong>{' '}
//                                             {getCurrencySymbol(selectedCurrency)}
//                                             {Number(remainingInSelectedCurrency).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {selectedCurrency}
//                                         </p>
//                                     )}
//                                     {selectedCurrency !== user.baseCurrency && (
//                                         <p className="mb-0 text-muted small">
//                                             Original: {getCurrencySymbol(user.baseCurrency)}{finalTotal.toLocaleString()} {user.baseCurrency}
//                                         </p>
//                                     )}
//                                 </div>
//                             </div>

//                             {paymentType === 'partial' && (
//                                 <div className="col-12 mt-3">
//                                     <div className="form-check">
//                                         <input className="form-check-input" type="checkbox" id="settleLater" checked={settleLater} onChange={handleSettleLaterToggle} />
//                                         <label className="form-check-label fw-bold" htmlFor="settleLater">Payment Settlement</label>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </Modal.Body>

//                     <Modal.Footer>
//                         <button
//                             className="btn btn-primary"
//                             onClick={handleSavePayment}
//                         // disabled={paymentType === 'partial' && (!paidAmount || Number(paidAmount) <= 0)}
//                         >
//                             Save Payment
//                         </button>
//                         <button className="btn btn-secondary" onClick={() => setShow(false)}>Cancel</button>
//                     </Modal.Footer>
//                 </Modal>
//             </div>
//             <InvoiceModal show={showRecipt}
//                 onHide={() => setShowRecipt(false)}
//                 t={t}
//                 testData={apiData}
//                 labInfo={user}
//                 selectedCurrency={currencyFor || user.baseCurrency}
//                 paidInSelectedCurrency={paidAmount}
//                 netTotalInSelectedCurrency={totalInSelectedCurrency}
//                 payment={payment}
//                 baseCurrency={user.baseCurrency}
//             />
//         </>
//     );
// }

import React, { useState, useRef, useEffect } from "react";
import { Table, Input, Label } from "reactstrap";
import Modal from 'react-bootstrap/Modal';
import { useLoader } from "../../_helper/LoaderContext";
import { masterDoctor, masterTest, testOrder } from "./services/search-patient";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import InvoiceModal from "../invoiceModel";
import { useTranslation } from "react-i18next";
import CurrencyAmountInput from "../CurrencyAmountInput";
import { useCurrency } from "../../_helper/currencyContext";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getDashboardData } from "../Dashboard/service/dashboard-service";
import { useCollection } from "../../_helper/dailyCollection";

export default function PatientTest({ selectedPatient,customerType }) {
    const [mode, setMode] = useState("Tests");
    const [masterOptions, setMasterOptions] = useState([]);
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const [selectedTests, setSelectedTests] = useState([]);
    const [selectedPackages, setSelectedPackages] = useState([]);
    const { t } = useTranslation();

    const allSelectedItems = [...selectedTests, ...selectedPackages];

    const [discountPercent, setDiscountPercent] = useState("");
    const [discountAmount, setDiscountAmount] = useState("0");
    const [taxPercent, setTaxPercent] = useState("0");
    const [selectedDoctorId, setSelectedDoctorId] = useState("");

    const [show, setShow] = useState(false);
    const [showRecipt, setShowRecipt] = useState(false);
    const [paymentType, setPaymentType] = useState('full');
    const [paidAmount, setPaidAmount] = useState(0); // Amount in selected currency
    const [paymentMethod, setPaymentMethod] = useState("Cash");
    const [apiData, setApiData] = useState({});
    const [selectedPaymentCurrency, setSelectedPaymentCurrency] = useState("INR"); // Tracks current currency

    const { setLoading } = useLoader();
    const [doctor, setDoctor] = useState([]);
    const dropdownRef = useRef(null);

    const { getCurrencySymbol, convertCurrency, currency: contextCurrency } = useCurrency();

    const [error, setError] = useState("");
    const [errorDr, setErrorDr] = useState("");
    const [user, setUser] = useState({});
    const [settleLater, setSettleLater] = useState(false);
    const { setDaily } = useCollection();
    const [overpaymentConfirmed, setOverpaymentConfirmed] = useState(false);

    // Base currency from lab settings
    const baseCurrency = user.baseCurrency || "INR";

    // Calculations in base currency
    const totalItemsAmount = allSelectedItems.reduce((sum, item) => sum + item.price, 0);
    const discountAmt = discountAmount ? Number(discountAmount) : 0;
    const amountAfterDiscount = totalItemsAmount - discountAmt;
    const taxAmt = Number((amountAfterDiscount * (Number(taxPercent) / 100)).toFixed(2));
    const finalTotal = amountAfterDiscount + taxAmt; // Always in base currency

    // Converted values in selected payment currency
    const totalInSelectedCurrency = convertCurrency(finalTotal, baseCurrency, selectedPaymentCurrency);

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        getMasterDoctor();
        const data = JSON.parse(localStorage.getItem("currentLab"));
        setUser(data);
        // Initialize selected currency to lab's base currency
        setSelectedPaymentCurrency(data.baseCurrency || "INR");
    }, []);

    // Sync paid amount when payment type changes
    useEffect(() => {
        if (paymentType === 'full') {
            const fullAmountInSelected = convertCurrency(finalTotal, baseCurrency, selectedPaymentCurrency);
            setPaidAmount(fullAmountInSelected);
        } else {
            // For partial: keep current paid amount, or reset to 0 if none
            if (paidAmount === convertCurrency(finalTotal, baseCurrency, selectedPaymentCurrency)) {
                setPaidAmount(0);
            }
        }
    }, [paymentType, finalTotal, selectedPaymentCurrency, baseCurrency]);

    // Update discount percent when amount changes
    useEffect(() => {
        if (discountAmount && totalItemsAmount > 0) {
            const perc = Math.round((Number(discountAmount) / totalItemsAmount) * 100);
            setDiscountPercent(perc.toString());
        }
    }, [discountAmount, totalItemsAmount]);

    const loadData = async () => {
        setLoading(true);
        try {
            const data = await masterTest();
            const mapped = data.data.data.allItems.map(item => ({
                id: item._id,
                name: item.name,
                price: item.cost || item.price || 0,
                isPackaged: item.isPackaged || false
            }));
            setMasterOptions(mapped);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const getMasterDoctor = async () => {
        setLoading(true);
        try {
            const res = await masterDoctor();
            if (res.data.success) setDoctor(res.data.data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const availableOptions = masterOptions.filter(opt =>
        opt.name.toLowerCase().includes(search.toLowerCase()) &&
        !allSelectedItems.some(sel => sel.id === opt.id)
    );

    const handleSearch = (e) => setSearch(e.target.value);

    const handleSelect = (option) => {
        if (option.isPackaged) {
            setSelectedPackages(prev => [...prev, option]);
        } else {
            setSelectedTests(prev => [...prev, option]);
        }
        setIsOpen(false);
        setSearch("");
    };

    const handleDelete = (id) => {
        setSelectedTests(prev => prev.filter(t => t.id !== id));
        setSelectedPackages(prev => prev.filter(p => p.id !== id));
    };

    useEffect(() => {
        const clickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", clickOutside);
        return () => document.removeEventListener("mousedown", clickOutside);
    }, []);

    const handlePaymentTypeChange = (e) => {
        setPaymentType(e.target.value);
        setSettleLater(false);
    };

    const openPaymentModal = () => {
        if (allSelectedItems.length === 0) {
            setError("Please select at least one Test or Package");
            return;
        }
        setShow(true);
    };

    const handleSavePayment = async () => {
        if (allSelectedItems.length === 0) {
            setError("Please select at least one Test or Package");
            return;
        }

        const selectedDoctor = doctor.find(d => d._id === selectedDoctorId);
        const commissionPercentage = selectedDoctor?.commissionPercent ?? 0;

        const baseTotalItemsAmount = totalItemsAmount;
        const baseDiscountAmt = discountAmt;
        const baseAmountAfterDiscount = amountAfterDiscount;
        const baseTaxAmt = taxAmt;
        const baseFinalTotal = finalTotal;
        const baseDoctorCommissionAmount = selectedDoctor
            ? Number(((baseAmountAfterDiscount * commissionPercentage) / 100).toFixed(2))
            : 0;

        const selectedCurrency = selectedPaymentCurrency;
        const totalInSelectedCurrency = convertCurrency(baseTotalItemsAmount, baseCurrency, selectedCurrency);
        const discountInSelected = convertCurrency(baseDiscountAmt, baseCurrency, selectedCurrency);
        const taxInSelected = convertCurrency(baseTaxAmt, baseCurrency, selectedCurrency);
        const netTotalInSelected = convertCurrency(baseFinalTotal, baseCurrency, selectedCurrency);
        const doctorCommissionInSelected = baseDoctorCommissionAmount;

        const paidInSelected = paymentType === 'full'
            ? netTotalInSelected
            : Number(paidAmount || 0);

        const dueInSelected = netTotalInSelected - paidInSelected;

        let isFullPayment = paymentType === "full";
        let isPartialPayment = paymentType === "partial";
        let isSettled = isPartialPayment && settleLater;
        let isPartialPaid = isPartialPayment && !settleLater;

        if (isPartialPayment && paidInSelected >= netTotalInSelected) {
            isFullPayment = true;
            isPartialPayment = false;
            isSettled = false;
            isPartialPaid = false;
        }

        let isPaid = isFullPayment || (isPartialPayment && settleLater);

        if (paidInSelected > netTotalInSelected && !overpaymentConfirmed) {
            const result = await Swal.fire({
                title: 'Overpayment Detected',
                icon: 'warning',
                html: `
                    <p>You are paying <strong>${getCurrencySymbol(selectedCurrency)}${paidInSelected.toFixed(2)}</strong></p>
                    <p>Which is more than the payable amount: <strong>${getCurrencySymbol(selectedCurrency)}${netTotalInSelected.toFixed(2)}</strong></p>
                    <p class="text-danger mt-3 fw-bold">
                        Extra: ${getCurrencySymbol(selectedCurrency)}${(paidInSelected - netTotalInSelected).toFixed(2)}
                    </p>
                `,
                showCancelButton: true,
                confirmButtonText: 'Yes, Proceed Anyway',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                reverseButtons: true,
            });

            if (!result.isConfirmed) {
                setLoading(false);
                return;
            }

            isPaid = true;
            setOverpaymentConfirmed(true);
        }

        setLoading(true);
        let isHospitalPatients = false;
        if(customerType === "hospitalClinic"){
            isHospitalPatients = true
        }
        try {
            const payload = {                
                isHospitalPatient:isHospitalPatients,
                patient: {
                    patientId: selectedPatient._id,
                    name: selectedPatient.fname || selectedPatient.full_name,
                    contact: selectedPatient.contact,
                    email: selectedPatient.email,
                    age: selectedPatient.age ? selectedPatient.age : 60,
                    gender: selectedPatient.gender,
                    patientType: "walkin"
                },
                lab: {
                    labId: user._id,
                    name: user.facility_name,
                    address: user.contact_person?.address,
                    createdByName: user.contact_person.first_name + " " + user.contact_person.last_name
                },
                doctor: selectedDoctor ? {
                    doctorId: selectedDoctor._id,
                    name: `${selectedDoctor.fname} ${selectedDoctor.lname || ""}`,
                    email: selectedDoctor.email || "",
                    mobile: selectedDoctor.mobile || "",
                    specialization: selectedDoctor.specialization || "",
                    commissionPercentage: commissionPercentage
                } : null,

                tests: selectedTests.map(t => ({ testId: t.id })),
                packages: selectedPackages.map(p => ({ packageId: p.id })),

                payment: {
                    currency: selectedCurrency,
                    paymentMode: paymentMethod,

                    totalPrice: Number(totalInSelectedCurrency.toFixed(2)),
                    paid: Number(paidInSelected.toFixed(2)),
                    netTotal: Number(netTotalInSelected.toFixed(2)),
                    due: Number(dueInSelected < 0 ? 0 : dueInSelected.toFixed(2)),

                    discount: {
                        amount: Number(discountInSelected.toFixed(2)),
                        percentage: discountPercent ? Number(discountPercent) : 0
                    },

                    doctorCommissionPercentage: commissionPercentage,
                    doctorCommissionAmount: Number(doctorCommissionInSelected.toFixed(2)),

                    isIGST: true,
                    IGST: Number(taxInSelected.toFixed(2)),
                    CGST: 0,
                    SGST: 0,
                    IGSTPercentage: Number(taxPercent),
                    CGSTPercentage: 0,
                    SGSTPercentage: 0,

                    baseCurrency: baseCurrency,
                    baseTotalPrice: baseTotalItemsAmount,
                    baseNetTotal: baseFinalTotal,
                    basePaid: isPaid ? baseFinalTotal : 0,
                    baseDiscountAmount: baseDiscountAmt,
                    baseIGST: baseTaxAmt,
                    baseDoctorCommissionAmount: baseDoctorCommissionAmount,

                    isPaid,
                    isSettled,
                    isPartialPaid,
                    discounAmount: baseAmountAfterDiscount
                }
            };

            const res = await testOrder(payload);
            if (res.data.success) {
                toast.success(res.data.message);
                setShow(false);
                setShowRecipt(true);
                setApiData(res.data.data);
                navigate(`${process.env.PUBLIC_URL}/test-list`);
                setOverpaymentConfirmed(false);

                const response = await getDashboardData();
                localStorage.setItem('collectionAmount', JSON.stringify(response.data.data.collectionAmount));
                setDaily(response.data.data.collectionAmount);
            }
        } catch (error) {
            console.log(error);
            toast.warning("Payment failed");
        } finally {
            setLoading(false);
        }
    };

    const handleSettleLaterToggle = async () => {
        const willSettle = !settleLater;
        const result = await Swal.fire({
            title: willSettle ? "Are you sure?" : "Are you sure?",
            text: willSettle ? "Do you want to settle this payment?" : "Do you want to un-settle this payment?",
            icon: "info",
            showCancelButton: true,
            cancelButtonText: "No, Cancel",
            confirmButtonText: willSettle ? "Yes, Settle it!" : "Yes, Unsettle it!",
            reverseButtons: false,
        });
        if (result.isConfirmed) {
            setSettleLater(willSettle);
        }
    };

    const formatAmount = (amount) => {
        return Number(amount || 0).toFixed(2);
    };

    const remainingInSelectedCurrency = totalInSelectedCurrency - paidAmount;

    return (
        <>
            <div className="row mt-4">
                <div className="col-md-8">
                    <div className="p-3 tw-rounded-lg" style={{ border: "2px solid #1b255b" }}>
                        <div className="row" ref={dropdownRef}>
                            <div className="col-md-12">
                                <button type="button" className="form-select text-start" onClick={() => setIsOpen(!isOpen)}>
                                    Search by {mode}...
                                </button>
                                {isOpen && (
                                    <div className="position-absolute bg-white text-black border rounded shadow w-100 mt-1" style={{ zIndex: 1050, maxHeight: "230px", overflowY: "auto" }}>
                                        <div className="p-2 border-bottom">
                                            <input type="text" className="form-control" placeholder="Search..." value={search} onChange={handleSearch} autoFocus />
                                        </div>
                                        {availableOptions.length > 0 ? availableOptions.map((opt, i) => (
                                            <div key={i} className="dropdown-item py-2 px-3" style={{ cursor: "pointer" }} onClick={() => {
                                                handleSelect(opt);
                                                setError("");
                                            }}>
                                                <div className="d-flex justify-content-between">
                                                    <span>{opt.name} {opt.isPackaged && <span className="badge bg-success ms-2">Package</span>}</span>
                                                    <span className="text-black">{getCurrencySymbol(baseCurrency)}{opt.price}</span>
                                                </div>
                                            </div>
                                        )) : <div className="px-3 py-2 text-muted">No results</div>}
                                    </div>
                                )}
                                <span className="tw-text-red-500">{error}</span>
                            </div>
                        </div>

                        <div className="recent-table mt-3 table-responsive currency-table tw-rounded-lg tw-border tw-border-black" style={{ maxHeight: "400px" }}>
                            <Table className="mb-0 table-center table-bordered table-hover bg-white text-dark" style={{ tableLayout: "fixed", width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th className="bg-primary text-center" style={{ width: "10%" }}><b>Sr.No</b></th>
                                        <th className="bg-primary" style={{ width: "55%" }}><b>Test Name</b></th>
                                        <th className="bg-primary" style={{ width: "20%" }}><b>Price</b></th>
                                        <th style={{ width: "15%" }} className="text-center bg-primary"><b>Action</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allSelectedItems.length > 0 ? (
                                        <>
                                            {allSelectedItems.map((item, idx) => (
                                                <tr key={item.id}>
                                                    <td className="text-center" style={{ color: "black" }}>{idx + 1}</td>
                                                    <td style={{ color: "black" }}>
                                                        {item.name}
                                                        {item.isPackaged && <span className="badge bg-success ms-2">Package</span>}
                                                    </td>
                                                    <td style={{ color: "black" }}>{getCurrencySymbol(baseCurrency)}{item.price}</td>
                                                    <td style={{ color: "black" }} className="text-center">
                                                        <i className="bi bi-trash text-danger cursor-pointer" onClick={() => handleDelete(item.id)}></i>
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr className="fw-bold">
                                                <td></td>
                                                <td style={{ color: "black" }}>Total</td>
                                                <td style={{ color: "black" }}>{getCurrencySymbol(baseCurrency)}{totalItemsAmount}</td>
                                                <td></td>
                                            </tr>
                                        </>
                                    ) : (
                                        <tr><td colSpan={4} className="text-center tw-font-bold" style={{ color: 'black' }}>No items selected</td></tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>

                        <div className="mt-4">
                            <h6 className="tw-font-semibold">Discount & Tax</h6>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label>Discount (%)</label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={discountPercent}
                                            onChange={(e) => {
                                                const percent = Number(e.target.value);
                                                setDiscountPercent(percent);
                                                if (totalItemsAmount > 0) {
                                                    const amount = Math.round((totalItemsAmount * percent) / 100);
                                                    setDiscountAmount(amount.toString());
                                                } else {
                                                    setDiscountAmount("0");
                                                }
                                            }}
                                        />
                                        <span className="input-group-text">= {discountAmt}</span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <label>Tax (GST)</label>
                                    <select className="form-select" value={taxPercent} onChange={(e) => setTaxPercent(e.target.value)}>
                                        <option value="0">0%</option>
                                        <option value="5">5%</option>
                                        <option value="12">12%</option>
                                        <option value="18">18%</option>
                                        <option value="28">28%</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label>Referred By Doctor </label>
                                    <select className="form-select" value={selectedDoctorId} onChange={(e) => {
                                        setSelectedDoctorId(e.target.value);
                                        setErrorDr("");
                                    }}>
                                        <option value="">Select</option>
                                        {doctor.map(d => <option key={d._id} value={d._id}>{d.fname} {d.lname}</option>)}
                                    </select>
                                    <span className="tw-text-red-500">{errorDr}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="p-3 tw-rounded-lg" style={{ border: "2px solid #1b255b" }}>
                        <h5>Payment Summary</h5>
                        <div className="mt-3">
                            <div className="d-flex justify-content-between"><span>Amount</span><strong>{getCurrencySymbol(baseCurrency)}{formatAmount(totalItemsAmount)}</strong></div>
                            <div className="d-flex justify-content-between text-danger"><span>Discount</span><strong>- {getCurrencySymbol(baseCurrency)}{formatAmount(discountAmt)}</strong></div>
                            <div className="d-flex justify-content-between"><span>Tax ({taxPercent}%)</span><strong>+ {getCurrencySymbol(baseCurrency)}{formatAmount(taxAmt)}</strong></div>
                            <hr />
                            <div className="d-flex justify-content-between fs-5 fw-bold text-primary">
                                <span>Final Total</span><span>{getCurrencySymbol(baseCurrency)}{formatAmount(finalTotal)}</span>
                            </div>
                        </div>
                        <div className="mt-3 text-end">
                            <button className="btn btn-primary me-2" onClick={openPaymentModal}>
                                Payment
                            </button>
                            <Link to={`${process.env.PUBLIC_URL}/search-patient`}>
                                <button className="btn btn-secondary">Cancel</button>
                            </Link>
                        </div>
                    </div>
                </div>

                <Modal show={show} onHide={() => setShow(false)}>
                    <Modal.Header closeButton style={{ backgroundColor: "#dbffe5" }}>
                        <Modal.Title>Process Payment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row g-3">
                            <div className="col-12">
                                <label>Payment Method</label>
                                <select className="form-select" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                                    <option>Cash</option>
                                    <option>Card</option>
                                    <option>UPI</option>
                                </select>
                            </div>

                            <div className="col-6">
                                <div className="radio radio-primary">
                                    <Input id="full" type="radio" name="paymentType" value="full" checked={paymentType === "full"} onChange={handlePaymentTypeChange} />
                                    <Label for="full" className="mb-0 pe-2">Full Paid</Label>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="radio radio-primary">
                                    <Input id="partial" type="radio" name="paymentType" value="partial" checked={paymentType === "partial"} onChange={handlePaymentTypeChange} />
                                    <Label for="partial" className="mb-0 pe-2">Partial Paid</Label>
                                </div>
                            </div>

                            <div className="col-12">
                                <CurrencyAmountInput
                                    label="Paid Amount"
                                    amount={paidAmount}
                                    onAmountChange={(value) => setPaidAmount(value)}
                                    onCurrencyChange={(currency) => setSelectedPaymentCurrency(currency)}
                                    disabled={paymentType === 'full'}
                                    defaultCurrency={baseCurrency}
                                />
                            </div>

                            <div className="col-12">
                                <div className="p-3 rounded border border-success" style={{ backgroundColor: "#f8fff9" }}>
                                    <p className="mb-1"><strong>Payment Type:</strong> {paymentType === 'full' ? "Full Paid" : "Partial Paid"}</p>
                                    <p className="mb-1">
                                        <strong>Amount to Pay:</strong>{' '}
                                        {getCurrencySymbol(selectedPaymentCurrency)}
                                        {paymentType === 'full'
                                            ? totalInSelectedCurrency.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                            : Number(paidAmount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                        } {selectedPaymentCurrency}
                                    </p>
                                    {paymentType === 'partial' && (
                                        <p className="mb-0 text-danger">
                                            <strong>Remaining:</strong>{' '}
                                            {getCurrencySymbol(selectedPaymentCurrency)}
                                            {Number(remainingInSelectedCurrency).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })} {selectedPaymentCurrency}
                                        </p>
                                    )}
                                    {selectedPaymentCurrency !== baseCurrency && (
                                        <p className="mb-0 text-muted small">
                                            Original: {getCurrencySymbol(baseCurrency)}{finalTotal.toLocaleString()} {baseCurrency}
                                        </p>
                                    )}
                                </div>
                            </div>

                            {paymentType === 'partial' && (
                                <div className="col-12 mt-3">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="settleLater" checked={settleLater} onChange={handleSettleLaterToggle} />
                                        <label className="form-check-label fw-bold" htmlFor="settleLater">Payment Settlement</label>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={handleSavePayment}>
                            Save Payment
                        </button>
                        <button className="btn btn-secondary" onClick={() => setShow(false)}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>

            <InvoiceModal
                show={showRecipt}
                onHide={() => setShowRecipt(false)}
                t={t}
                testData={apiData}
                labInfo={user}
                selectedCurrency={selectedPaymentCurrency}
                paidInSelectedCurrency={paidAmount}
                netTotalInSelectedCurrency={totalInSelectedCurrency}
                baseCurrency={baseCurrency}
            />
        </>
    );
}